module.controller('mobileIdCollectCtrl', ['$scope', '$state','baseURI', '$http', 'Transform', '$stateParams', '$window', '$timeout', function($scope, $state,baseURI, $http, Transform, $stateParams, $window, $timeout){
  var giftVirtualRegisterUrl = baseURI + 'gift-card/collect/virtual';
  $scope.passwordInputType = 'password';
  $scope.showValidateEmail = false;
  $scope.showUpdatedEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.attemptToChangeEmail = false;
  $scope.attemptToRedeemCode = false;

  var formattedPhone;

  // Get RedeemCode from state params
  $scope.formData.RedeemCode = $stateParams.RedeemCode;

  // set parent view form class
  $scope.parent.formType = 'floatingForm-form';

  var goToSuccessPage = function(message) {
    $state.go('root.redeem.success', {
      successMessage: message,
      username: $scope.formData.email,
    });
  };

  var goToWelcomePage = function(message) {
    $state.go('root.register.success', {
      successMessage: message,
      credentials: {
        username: $scope.formData.email,
        password: $scope.formData.password,
        brand: $scope.brand.name,
        _key: $scope.brand.api_key
      }
    });
  };

  $scope.attemptSubmission = function(joinForm){
    if(joinForm.$valid){
      verifyEmail();
    } else {
      $scope.submitted = true;
    }
  };

  $scope.formatPhone = function(){
    var phone = $scope.formData.phone;
    if (phone) {
      phone = phone.replace(/\D/g,'');
      if (phone.length > 10) {
        $scope.disableText = true;
        phone = '2102494100'; // ignore numbers with country code and use ours
      } else {
        $scope.disableText = false;
      }
    }

    formattedPhone = phone;
  };

  var redeemCode = function(){
    if($scope.attemptToRedeemCode) {
      return;
    }

    $scope.parent.overlayLoading = true;
    $scope.attemptToRedeemCode = true;
    var formData = $scope.formData;

    var request = {
      Email: $scope.formData.email,
      Phone: formattedPhone,
      RedeemCode: formData.RedeemCode,
      FirstName: formData.firstName,
      LastName: formData.lastName,
      Username: $scope.formData.email,
      Password: formData.password,
      CollectVirtual: "true",
      MobileIdState: $stateParams.State,
      MobileIdSHash: $stateParams.SHash,
    };

    $http({
      method: 'POST',
      url: baseURI + 'gift-card/redeem',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function (resp){
      var data = resp.data;

      $scope.attemptToRedeemCode = false;
      $scope.parent.overlayLoading = false;
      data.email = request.Email;

      if($scope.formData.textAlerts && !$scope.disableText){
        // set txt alerts for primary
        // if sub, set the subcard username
        data.textAlerts = {
          phoneNumber: formattedPhone,
          subcard: null
        };
      } else {
        data.textAlerts = false;
      }
      var message = "";
      if(typeof data.Data.OAuthData === "undefined" || data.Data.OAuthData === null) {
        $scope.parent.overlayLoading = false;
        message = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
        goToSuccessPage(message);
      } else {
        message = "Your card has now been registered, please proceed to the dashboard by clicking the button below.";
        goToWelcomePage(message);
      }
    }).catch(function(error, status){
      $scope.attemptToRedeemCode = false;
      $scope.parent.overlayLoading = false;
      $scope.alertError.show = true;
      switch(error.data.ErrorCode){
        case 31:
          $scope.alertError.show = false;
          var message = "We found an existing account for you and have applied these funds to that account. Please log in to your existing account to see these funds.";
          goToSuccessPage(message);
          break;
        default:
          $scope.alertError.message = 'Oops, we are unable to register your card at this time.';
          break;
      }
    });
  };

  // Verification email process
  var verifyEmail = function(){
    $scope.formData.verificationMethod = 'email';

    $scope.verificationMethodIsPhone = false;
    $scope.verificationMethodIsEmail = true;

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;

    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? formattedPhone : $scope.formData.email,
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? formattedPhone : $scope.formData.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function (resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    redeemCode();
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };
  };
}]);
